import LoadingComponent from './Loading';
export const Loading = LoadingComponent;
